import React, {PureComponent} from 'react';
import {connect, ConnectedProps} from 'react-redux';
import {HEADER, sendMobileAnalyticsEvent} from '@optimaxdev/analytics/mobile';

import {setQuickSearchParams} from 'reducers/quickSearch/quickSearch';
import {visibilityMenu} from 'actions/menu/mainMenu';
import {Icon} from 'components/baseIcon/baseIcon';
import * as SearchIcon from 'components/__helpers/icon/svg/common/search.svg';
import {toggleSearch} from 'reducers/header/header.js';

import s from './search.scss';

export const mapDispatchToProps = {
    setSearchPanelParams: setQuickSearchParams,
    toggleSearchPanel: toggleSearch,
    toggleMenu: visibilityMenu,
};

const connector = connect(null, mapDispatchToProps);

export type PropsType = ConnectedProps<typeof connector>;

/**
 *  Class-component for Search
 */
export class Search extends PureComponent<PropsType> {
    /**
     * openQuickSearch for close menu and open quickSearch
     */
    openQuickSearch = () => {
        const {setSearchPanelParams, toggleMenu, toggleSearchPanel} = this.props;

        sendMobileAnalyticsEvent(HEADER.SEARCH, {
            actionDescribe: ' - Opened From Menu',
            label: 'Opened From Menu',
        });
        setSearchPanelParams({
            withSuggestions: true,
            placeholder: 'Type what you looking for',
        });
        toggleMenu(false);
        toggleSearchPanel();
    };

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render() {
        return (
            <button
                type="button"
                className={s.searchBar}
                data-test-name="searchBarWrap"
                onClick={this.openQuickSearch}
                aria-label="Open quick search"
            >
                <span className={s.text}>Search</span>
                <div className={s.icon} role="presentation">
                    <Icon icon={SearchIcon} />
                </div>
            </button>
        );
    }
}

export const SearchConnected = connector(Search);
